import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Sprout, Puzzle, Gem } from 'lucide-react';
import SEO from '../components/SEO';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <Sprout size={32} />,
      title: "Authenticiteit",
      description: "Begeleiding op een oprechte en transparante manier, met echt luisteren en aandacht voor wie jij bent."
    },
    {
      icon: <Puzzle size={32} />,
      title: "Maatwerk",
      description: "Elke sessie en elk traject wordt afgestemd op jouw persoonlijke doelen en situatie, zodat je begeleiding krijgt die echt bij jou past."
    },
    {
      icon: <Gem size={32} />,
      title: "Kwaliteit",
      description: "Gecertificeerd volgens de MR-methode, met expertise in beweging, vitaliteit, stressmanagement en persoonlijke ontwikkeling."
    }
  ];


  return (
    <div className="about-page">
      <SEO
        title="Over CtheNature - Ervaren Wandelcoach in Omgeving Ravenstein | Chantal"
        description="Ontmoet Chantal, ervaren wandelcoach en oprichter van CtheNature. Professionele wandelcoaching volgens de MR-methode in Deursen-Dennenburg, omgeving Ravenstein. Persoonlijke coaching voor balans, energie en persoonlijke ontwikkeling."
        keywords="wandelcoach Chantal, over wandelcoaching, ervaren wandelcoach, CtheNature coach, wandelcoaching MR-methode, wandelcoach Ravenstein, coaching omgeving Ravenstein, professionele wandelcoach, natuurcoach, persoonlijke coaching, wandelcoaching ervaring"
        url="/over-ons"
      />
                   {/* Hero Section */}
             <section className="about-hero">
               <div className="about-hero-background">
                 <img 
                   //src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80" 
                   src="/waterval.jpg"
                   alt="Wandelcoaching in de natuur - CtheNature wandelcoach omgeving Ravenstein" 
                   className="about-hero-background-img"
                 />
                 <div className="about-hero-overlay"></div>
               </div>
               <div className="container">
          <motion.div 
            className="about-hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="about-hero-title">Over CtheNature</h1>
                         <p className="about-hero-subtitle">
                         Welkom! Hier vind je rust, balans en ruimte voor jezelf. Als wandelcoach help ik je stap voor stap weer in je kracht te komen.
             </p>
          </motion.div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section mission-section">
        <div className="container">
          <div className="mission-content">
            <motion.div 
              className="mission-text"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Mijn Missie</h2>
                                   <p className="mission-description">
                                   Jou helpen je energie, balans en focus terug te vinden. Stap voor stap, in je eigen tempo. 
                                   Wandelen in de natuur biedt rust en ruimte om weer helder te denken, terwijl coaching je helpt inzicht te krijgen in wat jou tegenhoudt en hoe je je doelen bereikt.
                     </p>
              <p className="mission-description">
              Ik begeleid je zodat je sterker, ontspannen en met meer plezier in je leven staat. 
              Of het nu gaat om stress verminderen, beter omgaan met veranderingen, of gewoon een moment voor jezelf: samen maken we het behapbaar en concreet, midden in de natuur.
              </p>
            </motion.div>
                               <motion.div
                     className="mission-image"
                     initial={{ opacity: 0, x: 50 }}
                     whileInView={{ opacity: 1, x: 0 }}
                     transition={{ duration: 0.8 }}
                     viewport={{ once: true }}
                   >
                     <img 
                       //src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80" 
                       src="/waterval.jpg"
                       alt="Wandelcoaching in de natuur - CtheNature wandelcoach omgeving Ravenstein" 
                       className="mission-image-img"
                     />
                   </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section values-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Mijn Waarden</h2>
            <p className="section-subtitle">
            Deze drie kernwaarden vormen de basis van mijn wandelcoaching. Ze geven richting aan hoe ik werk, hoe ik naar jou luister en hoe ik ervoor zorg dat je begeleiding krijgt die echt bij jou past. 
            Authenticiteit, maatwerk en kwaliteit zorgen ervoor dat jij in een veilige, vertrouwde en effectieve omgeving kunt groeien, ontdekken en herstellen.
            </p>
          </motion.div>

          <div className="values-grid">
            {values.map((value, index) => (
              <motion.div 
                key={index}
                className="value-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="value-icon">
                  {value.icon}
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section team-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Over Mij</h2>
            <p className="section-subtitle">
              Ontmoet de ervaren professional die jou zal begeleiden op jouw 
              wandelcoaching reis.
            </p>
          </motion.div>

          <div className="team-content">
            <motion.div 
              className="team-member"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
                                   <div className="member-image">
                       <img 
                         src="/chantal-notten.jpg" 
                         alt="Chantal - Wandelcoach en oprichter CtheNature | Professionele wandelcoaching" 
                         className="member-image-img"
                       />
                     </div>
                                   <div className="member-info">
                       <h3 className="member-name">Chantal</h3>
                       <p className="member-title">Coach & Oprichter</p>
                       <p className="member-description">
                       Rust, balans en energie zijn geen vanzelfsprekendheid. Door mijn werk in coaching heb ik ervaren hoe belangrijk het is om mentaal en fysiek goed voor jezelf te zorgen en hoe groot het effect kan zijn als dat lukt.
                       </p>
                       <p className="member-description">
                       Mijn passie is mensen begeleiden om meer rust, energie en balans in hun leven te brengen, met de natuur als inspirerende omgeving. Zelf heb ik ervaren hoe stress, overspanning en lichamelijke klachten je dagelijks leven kunnen beïnvloeden. Mijn hoofd zat vaak vol, ik stond continu “aan” en twijfelde aan alles wat ik deed. Wandelen werd voor mij een keerpunt.
                       </p>
                       <p className="member-description">
                       Het begon eenvoudig: gewoon even naar buiten, frisse lucht en op een rustig tempo een klein blokje om. Al snel merkte ik dat mijn hoofd rustiger werd, mijn lichaam ontspande en ik mijn energie terugvond. In de loop der jaren is wandelen niet alleen een vorm van herstel geworden, maar ook een passie. In 2025 liep ik voor het eerst de Nijmeegse Vierdaagse: vier dagen achter elkaar 50 km per dag. Het was een enorme fysieke uitdaging, maar mentaal misschien nog wel meer. Deze ervaring liet voor mezelf zien dat ik kan doorzetten, mijn grenzen kan verleggen en mijn eigen pad kan volgen, ook na uitdagende periodes. Het benadrukte hoe krachtig de combinatie van beweging, bewustzijn en ademhaling is en vormt nu de basis van mijn coachingsaanpak.
                       </p>
                       <p className="member-description">
                       Tijdens mijn wandelcoachsessies werk ik volgens de MR-methode: een combinatie van beweging, mindfulness en ademhalingstechnieken. Samen wandelen we door de natuur, creëren we rust in je hoofd en brengen we focus en ontspanning in je leven.
                       </p>
                <div className="member-credentials">
                  <span>Gecertificeerd Coach</span>
                  <span>Natuur- & Wandelcoach</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="cta-title">Klaar om te Beginnen?</h2>
            <p className="cta-subtitle">
              Neem contact op voor een gratis kennismakingsgesprek en ontdek hoe 
              ik jou kan helpen groeien.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Neem Contact Op
              </Link>
              <Link to="/diensten" className="btn btn-secondary">
                Bekijk Diensten
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
